// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const manaphy: PokeData = {
  "id": 490,
  "name": "manaphy",
  "height": 3,
  "weight": 14,
  "base_experience": 270,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "supersonic",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "confusion",
    "bubble",
    "acid-armor",
    "charm",
    "rain-dance",
    "whirlpool",
    "dive",
    "tail-glow",
    "water-sport",
    "water-pulse",
    "heart-swap",
    "aqua-ring",
    "zen-headbutt",
    "moonblast",
    "take-heart"
  ],
  "moves": [
    "supersonic",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "whirlpool",
    "zen-headbutt",
    "moonblast",
    "aqua-jet",
    "liquidation",
    "life-dew",
    "aqua-cutter",
    "aqua-tail"
  ],
  "evolution_chain": {
    "id": 250,
    "item": null,
    "species": [
      {
        "name": "phione",
        "order": 490,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "manaphy",
        "order": 491,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
